(function () {
  var SECTION_SELECTOR = '.oddit-section-main-collection-grid';
  var OPEN_CLASS = 'oddit-section-main-collection-grid__sort-options--open';
  var DRAWER_OPEN_CLASS = 'oddit-section-main-collection-grid__filter-drawer--open';

  function initSection(section) {
    if (!section || section.dataset.odditGridInitialized === 'true') return;
    section.dataset.odditGridInitialized = 'true';

    initSort(section);
    initFilterDrawer(section);
    initHoverMedia(section);
  }

  function initHoverMedia(section) {
    var prefersReducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var videos = section.querySelectorAll('[data-hover-video]');
    for (var i = 0; i < videos.length; i++) {
      setupHoverVideo(videos[i], prefersReducedMotion);
    }
  }

  function setupHoverVideo(video, prefersReducedMotion) {
    var card = video.closest('.oddit-product-card');
    if (!card) return;

    function safePlay() {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    card.addEventListener('mouseenter', function () {
      if (prefersReducedMotion) return;
      video.muted = true;
      safePlay();
    });

    card.addEventListener('mouseleave', function () {
      video.pause();
      video.currentTime = 0;
    });
  }

  function initSort(section) {
    var sort = section.querySelector('[data-sort]');
    var trigger = sort && sort.querySelector('[data-sort-trigger]');
    var menu = sort && sort.querySelector('[data-sort-menu]');
    if (!sort || !trigger || !menu) return;

    function openMenu() {
      sort.classList.add(OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'true');
      menu.removeAttribute('hidden');
      document.addEventListener('click', handleOutsideClick, true);
      document.addEventListener('keydown', handleKeydown);
    }

    function closeMenu() {
      sort.classList.remove(OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'false');
      menu.setAttribute('hidden', '');
      document.removeEventListener('click', handleOutsideClick, true);
      document.removeEventListener('keydown', handleKeydown);
    }

    function handleOutsideClick(e) {
      if (!sort.contains(e.target)) closeMenu();
    }

    function handleKeydown(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        closeMenu();
        trigger.focus();
      }
    }

    trigger.addEventListener('click', function () {
      if (trigger.getAttribute('aria-expanded') === 'true') {
        closeMenu();
      } else {
        openMenu();
      }
    });

    var options = menu.querySelectorAll('[data-sort-option]');
    for (var i = 0; i < options.length; i++) {
      options[i].addEventListener('click', function (e) {
        var value = e.currentTarget.getAttribute('data-sort-value');
        if (!value) return;
        applySort(value);
      });
    }
  }

  function applySort(value) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    // Reset to the first page so the new order starts from the top.
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  }

  function initFilterDrawer(section) {
    var trigger = section.querySelector('[data-collection-filter-trigger]');
    var drawer = section.querySelector('[data-filter-drawer]');
    if (!trigger || !drawer) return;

    var overlay = drawer.querySelector('[data-filter-overlay]');

    function openDrawer() {
      drawer.classList.add(DRAWER_OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', handleKeydown);
      var closeBtn = drawer.querySelector('[data-filter-close]');
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      drawer.classList.remove(DRAWER_OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', handleKeydown);
      trigger.focus();
    }

    function handleKeydown(e) {
      if (e.key === 'Escape' || e.keyCode === 27) closeDrawer();
    }

    trigger.addEventListener('click', openDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // The drawer's close button (handled by oddit-section-filter-sidebar.js)
    // dispatches this bubbling event.
    drawer.addEventListener('oddit:filter-drawer:close', closeDrawer);
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
